
import { useState, useRef } from 'react';
import CountdownTimer from "../Student_Desktop/CountdownTimer";
import { jwtDecode } from "jwt-decode";
import { BASEURL } from "../../constants";
import axios from 'axios';
import { Toggle, LeftChevron, RightChevron, MarkFinishIcon, ArrowDown } from "../Icons/icons";


const TestConsumption = ({ setTestDetails, setTestTimeMinutes, testGoverning, setTestGoverning, testDetails, showFailModal,
    setShowFailModal, showPassModal, setShowPassModal, isTestSubmitted, setIsTestSubmitted, setIsTestStarted,
    setSidebarToggle, attemptNumber, testStartTime, sharedCourseId, courseId, selectedTestId, testTimeMinutes,
    topicName, testName, questionsArray, currentQuestionId, question, setCurrentQuestionId, setQuestion,
    setQuestionsArray }) => {
    console.log("Test Consumption is called", questionsArray);

    const [isSpeaking, setIsSpeaking] = useState(false);
    const [showSubmitModal, setShowSubmitModal] = useState(false);
    let currentUtterance = useRef(null);

    const token = localStorage.getItem('auth');
    const decoded = jwtDecode(token);
    const studentId = decoded.user_id;

    function chunkText(text, maxChunkSize = 150) {
        const chunks = [];
        let start = 0;
        while (start < text.length) {
            let end = start + maxChunkSize;
            if (end < text.length) {
                // Ensure we don't split a word by finding the last space within the chunk
                while (end > start && text[end] !== ' ') {
                    end--;
                }
                if (end === start) {
                    end = start + maxChunkSize; // No space found, force split at maxChunkSize
                }
            }
            chunks.push(text.slice(start, end).trim());
            start = end + 1; // Skip the space at the split point
        }
        return chunks;
    }

    function speakChunks(chunks, index = 0) {
        if (index < chunks.length) {
            const utterance = new SpeechSynthesisUtterance(chunks[index]);
            utterance.lang = 'hi-IN';
            utterance.onend = () => {
                console.log('Utterance finished:', chunks[index]);
                speakChunks(chunks, index + 1);
            };
            utterance.onerror = (event) => {
                console.error('SpeechSynthesisUtterance.onerror', event);
            };
            console.log('Speaking chunk:', chunks[index]);
            currentUtterance = utterance;
            window.speechSynthesis.speak(utterance);
        }
    }

    function handleTextToSpeech() {
        let text = question.text;

        if (text) {
            const chunks = chunkText(text);
            speechSynthesis.cancel();
            speakChunks(chunks);
        } else {
            alert('No text in the slide')
        }

    }

    function handleSpeechStop() {
        if (currentUtterance) {
            window.speechSynthesis.cancel(); // Cancel the current utterance
            setIsSpeaking(false); // Update the speaking state
            currentUtterance = null;
        }
    }
    const disableStyle = {
        pointerEvents: "none",
        color: "grey"
    }

    function disableNext() {
        if (currentQuestionId === questionsArray[questionsArray.length - 1].id) return disableStyle;
        return {}
    }

    function disablePrevious() {
        if (currentQuestionId === questionsArray[0].id) return disableStyle;
        return {}
    }

    function nextQuestion() {
        //[{id}{id}{id}]
        const currentQuestionIndex = questionsArray.findIndex((questionsArray) => questionsArray.id === currentQuestionId);
        setCurrentQuestionId(questionsArray[currentQuestionIndex + 1].id);
        setQuestion(questionsArray[currentQuestionIndex + 1]);
    }

    function previousQuestion() {
        const currentQuestionIndex = questionsArray.findIndex(questionsArray => questionsArray.id === currentQuestionId);
        setCurrentQuestionId(questionsArray[currentQuestionIndex - 1].id);
        setQuestion(questionsArray[currentQuestionIndex - 1]);

    }

    function onFinish() {
        console.log('auto submit test');
    }

    function handleTestSubmit() {
        //send the student answers 
        const testFinishTime = new Date().toISOString().slice(0, 19).replace('T', ' ');
        axios.post(`${BASEURL}/api/submit-student-answers`, {
            testId: selectedTestId,
            courseId: sharedCourseId,
            studentAnswers: questionsArray,
            studentId: studentId,
            startTime: testStartTime,
            finishTime: testFinishTime,
            attemptNumber: attemptNumber ? (attemptNumber + 1) : 1
        }).then((response) => {

            console.log('response', response)
            //pass fail 
            // reset the students answers { answers : [] , attempted : true } 
            setQuestionsArray((questionsArray) => {
                return questionsArray.map((question) => {
                    return { ...question, answers: [], attempted: false }
                })
            })
            setQuestion((question) => {
                const firstQuestion = questionsArray[0];
                return { ...firstQuestion, answers: [], attempted: false }
            })
            setCurrentQuestionId(questionsArray[0].id);
            setTestGoverning((testGoverning) => {
                return { ...testGoverning, isTestStarted: false }
            })
            // setIsTestSubmitted(true);
            // setIsTestStarted(false);
            if (response.data.result === 'pass') {
                setTestDetails((testDetails) => {
                    return { ...testDetails, attempted: true, passOrFail: response.data.result, score: response.data.correctAnswerCount, attemptNumber }
                })
            }
            if (response.data.result === 'fail') {
                setTestDetails((testDetails) => {
                    return { ...testDetails, attempted: true, passOrFail: response.data.result, score: response.data.correctAnswerCount }
                })
            }
        })
    }

    function hanldeTestStart() {
        //fetch the questions set the questions Array , set the timer time 

        axios.get(`${BASEURL}/api/get-test-data`, {
            params: {
                testId: selectedTestId
            }
        }).then((response) => {

            axios.get(`${BASEURL}/api/get-test-duration`, {
                params: {
                    testId: selectedTestId
                }
            }).then((getDurationResponse) => {
                //response should be questionsArray 
                //well we are not setting anything here 
                const questionsArray = response.data.map((question) => {
                    return { ...question, attempted: false, answers: [] }
                });
                console.log("questionsArray to be setted", questionsArray);
                const { testTimeHours, testTimeMinutes, numberOfQuestions } = getDurationResponse.data[0];
                //[{ } , { } ]
                const imagekeyArray = questionsArray.map((question) => {
                    if (question.image_data.image) {
                        return question.image_key
                    }
                }).filter((key) => key)

                if (imagekeyArray.length) {
                    const imagePromisesArray = imagekeyArray.map((key) => {
                        if (key) {
                            return axios.get(`${BASEURL}/api/get-image`, {
                                params: {
                                    imageId: key
                                }
                            })
                        }
                    })

                    Promise.all(imagePromisesArray)
                        .then((imagesResponse) => {
                            //[{ dataUrl: urlObject, status: "success" }]

                            imagesResponse.forEach((responseObj, index) => {
                                const key = imagekeyArray[index];
                                const questionIndex = questionsArray.findIndex(question => question.image_key === key);
                                questionsArray[questionIndex] = { ...questionsArray[questionIndex], image_data: { ...questionsArray[questionIndex].image_data, image: responseObj.data.dataUrl } }
                            })
                            setQuestionsArray(questionsArray);
                            setTestGoverning((testGoverning) => {
                                return { ...testGoverning, isTestStarted: true }
                            })
                            setQuestion(questionsArray[0]);
                            setCurrentQuestionId(questionsArray[0].id);

                            setTestTimeMinutes(testTimeMinutes ? testTimeMinutes : 0);
                        })
                } else {
                    console.log('setting test data', questionsArray)
                    setQuestionsArray(questionsArray);

                    console.log("setting properly the question", questionsArray[0])
                    setQuestion(questionsArray[0]);
                    setCurrentQuestionId(questionsArray[0].id);
                    setTestGoverning((testGoverning) => {
                        return { ...testGoverning, isTestStarted: true }
                    })
                    setTestTimeMinutes(testTimeMinutes ? testTimeMinutes : 0);
                }
            })
        })
    }


    function handleSingleChoiceAnswer(e) {
        const value = e.target.value;
        setQuestion((question) => {
            return { ...question, answers: [value], attempted: true }
        })
        setQuestionsArray((questionsArray) => {
            return questionsArray.map((q) => {
                if (q.id === question.id) {
                    return { ...q, answers: [value], attempted: true }
                } else {
                    return q
                }
            })

        })
    }
    function handleMultipleChoiceAnswer(e) {
        let arr = [...question.answers];
        const value = e.target.value;
        if (e.target.checked) {
            arr.push(value)
        } else {
            arr = arr.filter((item) => item !== value);
        }

        const attemptedOrNot = arr.length > 0 ? true : false
        setQuestion((question) => {
            return { ...question, answers: arr, attempted: attemptedOrNot }
        })
        setQuestionsArray((questionsArray) => {
            return questionsArray.map((q) => {
                if (q.id === question.id) {
                    return { ...q, answers: arr, attempted: attemptedOrNot }
                } else {
                    return q
                }
            })
        })
    }


    function nextQuestion() {
        //[{id}{id}{id}]
        const currentQuestionIndex = questionsArray.findIndex((questionsArray) => questionsArray.id === currentQuestionId);
        setCurrentQuestionId(questionsArray[currentQuestionIndex + 1].id);
        setQuestion(questionsArray[currentQuestionIndex + 1]);
    }

    function previousQuestion() {
        const currentQuestionIndex = questionsArray.findIndex(questionsArray => questionsArray.id === currentQuestionId);
        setCurrentQuestionId(questionsArray[currentQuestionIndex - 1].id);
        setQuestion(questionsArray[currentQuestionIndex - 1]);

    }

    function disableNextQuestion() {
        if (currentQuestionId === questionsArray[questionsArray.length - 1].id) return disableStyle;
        return {}
    }

    function disablePreviousQuestion() {
        if (currentQuestionId === questionsArray[0].id) return disableStyle;
        return {}
    }

    function saveAndNext() {
        if (question.attempted) {
            nextQuestion()
        }
    }

    function clearResponse() {
        setQuestion((question) => {
            return { ...question, answers: [], attempted: false }
        })
        setQuestionsArray((questionsArray) => {
            return questionsArray.map((q) => {
                if (q.id === question.id) {
                    return { ...q, answers: [], attempted: false }
                } else {
                    return q
                }
            })

        })
    }

    if (!testDetails) {
        return
    }

    if (testGoverning.isTestStarted) {

        return (
            <>
                {
                    showSubmitModal &&
                    <div className="relative  z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">

                        <div className="fixed  inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

                        <div className="fixed h-full  inset-0 z-10 w-screen overflow-y-auto">
                            <div className="flex min-h-full h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">

                                <div style={{ minWidth: '300px' }} className="relative p-3 h-auto transform flex-col justify-evenly rounded-lg bg-white text-left shadow-xl transition-all my-8">

                                    <div className='flex w-full justify-center'>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="#dc2626" className="size-10">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                                        </svg>
                                    </div>
                                    <div className="flex justify-center py-2 px-3">
                                        <span className='font-bold'>Are you sure?</span>

                                    </div>
                                    <div className="flex items-center py-2 px-3 flex-col">
                                        <span className='text-xs text-gray-600'>{`You want to submit the test`}</span>
                                        <span className='text-xs font-bold'>{`Attempted: ${questionsArray.filter(q => q.attempted).length} / ${questionsArray.length}`}</span>
                                    </div>
                                    <div className="flex justify-around">
                                        <button className='px-3 py-1 border-2 text-xs' onClick={() => { setShowSubmitModal(false) }}>Cancel</button>
                                        <button onClick={handleTestSubmit} className='px-3 py-1 bg-customPrimaryPurple text-white text-xs'>Yes, submit it!</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="w-screen h-screen ">
                    <header className="flex justify-between px-6 py-4 shadow-md" style={{ boxShadow: '0px 2px 2px 0px rgba(20, 29, 34, 0.10);' }}>
                        <div>Question {questionsArray.findIndex(q => q.id === currentQuestionId) + 1}</div>
                        <div>
                            {
                                questionsArray && (
                                    <div className="flex items-center gap-2">
                                        <span style={disablePreviousQuestion()} onClick={previousQuestion} className="flex items-center justify-center cursor-pointer border border-[#E0E0E0] w-[30px] h-[30px]">
                                            <LeftChevron />
                                        </span>
                                        {/* <svg style={disablePreviousQuestion()} onClick={previousQuestion} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 cursor-pointer">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                                    </svg> */}
                                        <span style={disableNextQuestion()} onClick={nextQuestion} className="flex items-center justify-center cursor-pointer border border-[#E0E0E0] w-[30px] h-[30px]">
                                            <RightChevron />
                                        </span>
                                        {/* <svg style={disableNextQuestion()} onClick={nextQuestion} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 cursor-pointer">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                                    </svg> */}
                                    </div>
                                )
                            }
                        </div>
                    </header>
                    <section className="flex p-6">
                        <div className="grow mr-6">
                            <div className="border border-borderColor mb-4 p-4 text-sm select-none" dangerouslySetInnerHTML={{ __html: question.text }}>
                                {/* {
                                    question.text
                                } */}
                            </div>
                            <div>
                                {
                                    question.answer_type !== 'audio' ? (
                                        <>
                                            <section
                                                className="text-xs flex flex-col gap-2"
                                            >
                                                {
                                                    question.answer_type === 'single' ? (
                                                        question.options.map((option, optionIndex) => {
                                                            return (
                                                                <div className="flex gap-1 h-[40px] border border-solid border-gray-300 items-center px-2 py-0" key={optionIndex} >
                                                                    <span className="flex items-center pr-2 border-r border-solid border-gray-300 h-full text-xl font-semibold" >{`${String.fromCharCode(65 + optionIndex)}`}</span>
                                                                    <input className="text-xl" type="radio" name="radio" checked={question.answers.includes(option)} value={option} onChange={handleSingleChoiceAnswer} />
                                                                    <div className="w-4/5 outline-none text-sm font-normal">{option}</div>

                                                                </div>
                                                            )
                                                        })
                                                    ) : (
                                                        question.answer_type === 'multiple' ? (
                                                            question.options.map((option, optionIndex) => {
                                                                console.log('maping options ', option, question.correct_answer.includes(option));

                                                                return (
                                                                    <div className="flex gap-1 items-center px-2  py-3 rounded-lg" style={{ border: 'solid 0.5px #e1deff' }} key={optionIndex} >
                                                                        <span className="flex items-center pr-2 border-r border-solid border-gray-300 h-full text-xl font-semibold">{`${String.fromCharCode(65 + optionIndex)})`}</span>
                                                                        <input className="text-xl" type="checkbox" value={option} checked={question.answers.includes(option)} name="radio" onChange={handleMultipleChoiceAnswer} />
                                                                        <div className="w-4/5 outline-none text-sm font-normal">{option}</div>

                                                                    </div>
                                                                )
                                                            }
                                                            )
                                                        ) : (
                                                            null
                                                            // return component for audio 
                                                        )
                                                    )
                                                }
                                            </section>
                                        </>
                                    ) : (null)
                                }
                            </div>
                        </div>
                        <div className="flex shrink-0 flex-col w-[362px] p-6 gap-6 border border-borderColor">
                            <div className="w-full bg-[#F1F3F6] p-6">
                                <CountdownTimer time={testTimeMinutes} onFinish={handleTestSubmit} isTestSubmitted={testGoverning.isTestSubmitted} />
                            </div>
                            <div className="flex flex-col">
                                <div>Question</div>
                                <div>
                                    5/10
                                </div>
                            </div>
                            <div className="flex justify-between text-sm">
                                <div className="flex gap-2">
                                    <div className="w-5 h-5 bg-customPrimaryPurple"></div>
                                    <div>Answered</div>
                                </div>
                                <div className="flex gap-2">
                                    <div className="w-5 h-5 bg-white border border-borderColor"></div>
                                    <div>
                                        In progress
                                    </div>
                                </div>
                                <div className="flex gap-2">
                                    <div className="w-5 h-5 bg-[#F2994A]"></div>
                                    <div>
                                        Mark
                                    </div>
                                </div>
                            </div>
                            <div className="p-6 w-full flex gap-4 flex-wrap bg-[#F1F3F6]">
                                {
                                    questionsArray.map((q, index) => {

                                        if (q.attempted) {
                                            return <div className="w-[40px] flex justify-center items-center h-[40px] border border-borderColor bg-white" style={{ backgroundColor: '#382F8A', color: 'white', border: '4px solid #382F8A !important' }}>{index + 1}</div>

                                        }
                                        return (
                                            <div className="w-[40px] flex justify-center items-center h-[40px] border border-borderColor bg-white" style={q.id === currentQuestionId ? { border: '1px solid #382F8A' } : {}}>{index + 1}</div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </section>
                    <footer className="px-6 py-4 flex justify-between border border-borderColor fixed bottom-0 w-full shadow-[0px -4px 8px 0px rgba(39, 48, 52, 0.15)]">
                        <div className="flex gap-4 items-center" >
                            <div onClick={clearResponse} className="cursor-pointer text-sm h-[40px] w-[190px] border border-borderColor flex items-center justify-center">
                                Clear Response
                            </div>
                            {/* <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
                                <path d="M0.5 1L5 0.5L16 2V9L15 11.5H10L0.5 10L0 9L0.5 1Z" fill="#4F4F4F" />
                            </svg>
                        </div> */}
                        </div>
                        <div className="flex gap-4 items-center ">
                            <div onClick={saveAndNext} className="cursor-pointer text-sm h-[40px] w-[190px] border border-borderColor flex items-center justify-center">Save & next</div>
                            <div onClick={() => { setShowSubmitModal(true) }} className="cursor-pointer text-sm w-[120px] h-[40px] flex items-center justify-center text-white p-3 bg-customPrimaryPurple">Submit</div>
                        </div>
                    </footer>
                </div>

            </>

        )
    }
    if (testDetails?.attempted) {

        //if passed 
        if (testDetails?.passOrFail === 'pass') {
            return (
                <div className="grow w-full p-20 overflow-y-scroll">
                    <div className="flex flex-col gap-8 p-8 w-full bg-[#F1F3F6] justify-center">
                        <div className="font-semibold text-2xl text-center w-full">
                            Test Passed
                        </div>
                        <div className="flex gap-6 justify-center">
                            <div className="flex p-4 gap-4 border bg-white items-center border-borderColor shadow-md w-[273px] h-[88px]">
                                <div className="p-4 rounded-full bg-[#EA852A19]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M19 19H8C4.70017 19 3.05025 19 2.02513 17.9749C1 16.9497 1 15.2998 1 12V1" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M4 10H4.00898M6.9982 10H7.00718M9.99641 10H10.0054M12.9946 10H13.0036M15.9928 10H16.0018M18.991 10H19" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M4 5C4.67348 3.87847 5.58712 3 6.99282 3C12.9359 3 9.59545 15 15.9819 15C17.3976 15 18.3057 14.1157 19 13" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="text-[#4F4F4F] font-normal text-sm">Time Allowed</div>
                                    <div>{testDetails.timeLimit} minutes</div>
                                </div>
                            </div>
                            <div className="flex p-4 gap-4 border bg-white items-center border-borderColor shadow-md w-[273px] h-[88px]">
                                <div className="p-4 rounded-full bg-[#EA852A19]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                        <path d="M21.6667 10.5667C21.6667 15.8499 17.1889 20.1334 11.6667 20.1334C11.0173 20.1343 10.3699 20.0742 9.73207 19.9545C9.27298 19.8682 9.04344 19.8251 8.88318 19.8496C8.72293 19.8741 8.49583 19.9948 8.04164 20.2364C6.75679 20.9197 5.25861 21.161 3.81777 20.893C4.3654 20.2194 4.7394 19.4112 4.90443 18.5448C5.00443 18.0148 4.75666 17.5 4.38555 17.1231C2.69999 15.4115 1.66666 13.1051 1.66666 10.5667C1.66666 5.28357 6.14443 1 11.6667 1C17.1889 1 21.6667 5.28357 21.6667 10.5667Z" stroke="#F2994A" stroke-width="1.5" stroke-linejoin="round" />
                                        <path d="M9.66666 8.84615C9.66666 7.82655 10.5621 7 11.6667 7C12.7712 7 13.6667 7.82655 13.6667 8.84615C13.6667 9.21368 13.5503 9.55612 13.3498 9.84381C12.7521 10.7012 11.6667 11.5189 11.6667 12.5385V13" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M11.6667 15.5H11.6756" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="text-[#4F4F4F] font-normal text-sm">No. of questions</div>
                                    <div>{testDetails.numberOfQuestions}</div>
                                </div>
                            </div>
                            <div className="flex p-4 gap-4 border bg-white items-center border-borderColor shadow-md w-[273px] h-[88px]">
                                <div className="p-4 rounded-full bg-[#EA852A19]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
                                        <path d="M19.781 7.2C19.8334 8.25014 19.8334 9.49936 19.8334 11C19.8334 15.4783 19.8334 17.7175 18.4421 19.1088C17.0509 20.5 14.8117 20.5 10.3334 20.5C5.85503 20.5 3.61586 20.5 2.22462 19.1088C0.833374 17.7175 0.833374 15.4783 0.833374 11C0.833374 6.52166 0.833374 4.28249 2.22462 2.89124C3.61586 1.5 5.85503 1.5 10.3334 1.5C11.4053 1.5 12.3489 1.5 13.1834 1.51908" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M6.33337 10.5C6.33337 10.5 7.83337 10.5 9.83337 14C9.83337 14 14.8922 4.83333 19.8334 3" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="text-[#4F4F4F] font-normal text-sm">Attempts</div>
                                    <div>{attemptNumber}</div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full text-center">
                            <span className="w-[178px] h-[48px] px-3 py-2 bg-customPrimaryPurple text-white">Score : {testDetails.score} </span>
                        </div>
                        <div className="w-full text-center">
                            <button className="w-[178px] h-[48px] px-3 py-2 bg-customPrimaryPurple text-white">Passed</button>
                        </div>
                        <div className="w-full">
                            <h1 className="font-bold">Instructions:</h1>
                            <ul class="list-disc list-inside text-gray-800">
                                <li>The test will automatically submit when the timer runs out, so manage your time wisely.</li>
                                <li>Please attempt all the questions to maximize your score.</li>
                                <li>The test has a strict time limit, so stay focused throughout.</li>
                                <li>Maintain honesty and integrity—avoid any unfair practices.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            )
        }


        if (testDetails?.passOrFail === 'fail') {
            return (
                <div className="grow w-full p-20 overflow-y-scroll">
                    <div className="flex flex-col gap-8 p-8 w-full bg-[#F1F3F6] justify-center">
                        <div className="font-semibold text-2xl text-center w-full">
                            Test Failed
                        </div>
                        <div className="flex gap-6 justify-center">
                            <div className="flex p-4 gap-4 border bg-white items-center border-borderColor shadow-md w-[273px] h-[88px]">
                                <div className="p-4 rounded-full bg-[#EA852A19]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M19 19H8C4.70017 19 3.05025 19 2.02513 17.9749C1 16.9497 1 15.2998 1 12V1" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M4 10H4.00898M6.9982 10H7.00718M9.99641 10H10.0054M12.9946 10H13.0036M15.9928 10H16.0018M18.991 10H19" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M4 5C4.67348 3.87847 5.58712 3 6.99282 3C12.9359 3 9.59545 15 15.9819 15C17.3976 15 18.3057 14.1157 19 13" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="text-[#4F4F4F] font-normal text-sm">Time Allowed</div>
                                    <div>{testDetails.timeLimit} minutes</div>
                                </div>
                            </div>
                            <div className="flex p-4 gap-4 border bg-white items-center border-borderColor shadow-md w-[273px] h-[88px]">
                                <div className="p-4 rounded-full bg-[#EA852A19]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                        <path d="M21.6667 10.5667C21.6667 15.8499 17.1889 20.1334 11.6667 20.1334C11.0173 20.1343 10.3699 20.0742 9.73207 19.9545C9.27298 19.8682 9.04344 19.8251 8.88318 19.8496C8.72293 19.8741 8.49583 19.9948 8.04164 20.2364C6.75679 20.9197 5.25861 21.161 3.81777 20.893C4.3654 20.2194 4.7394 19.4112 4.90443 18.5448C5.00443 18.0148 4.75666 17.5 4.38555 17.1231C2.69999 15.4115 1.66666 13.1051 1.66666 10.5667C1.66666 5.28357 6.14443 1 11.6667 1C17.1889 1 21.6667 5.28357 21.6667 10.5667Z" stroke="#F2994A" stroke-width="1.5" stroke-linejoin="round" />
                                        <path d="M9.66666 8.84615C9.66666 7.82655 10.5621 7 11.6667 7C12.7712 7 13.6667 7.82655 13.6667 8.84615C13.6667 9.21368 13.5503 9.55612 13.3498 9.84381C12.7521 10.7012 11.6667 11.5189 11.6667 12.5385V13" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M11.6667 15.5H11.6756" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="text-[#4F4F4F] font-normal text-sm">No. of questions</div>
                                    <div>{testDetails.numberOfQuestions}</div>
                                </div>
                            </div>
                            <div className="flex p-4 gap-4 border bg-white items-center border-borderColor shadow-md w-[273px] h-[88px]">
                                <div className="p-4 rounded-full bg-[#EA852A19]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
                                        <path d="M19.781 7.2C19.8334 8.25014 19.8334 9.49936 19.8334 11C19.8334 15.4783 19.8334 17.7175 18.4421 19.1088C17.0509 20.5 14.8117 20.5 10.3334 20.5C5.85503 20.5 3.61586 20.5 2.22462 19.1088C0.833374 17.7175 0.833374 15.4783 0.833374 11C0.833374 6.52166 0.833374 4.28249 2.22462 2.89124C3.61586 1.5 5.85503 1.5 10.3334 1.5C11.4053 1.5 12.3489 1.5 13.1834 1.51908" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                        <path d="M6.33337 10.5C6.33337 10.5 7.83337 10.5 9.83337 14C9.83337 14 14.8922 4.83333 19.8334 3" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div>
                                    <div className="text-[#4F4F4F] font-normal text-sm">Attempts</div>
                                    <div>{attemptNumber}</div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full text-center">
                            <span className="w-[178px] h-[48px] px-3 py-2 bg-customPrimaryPurple text-white">Score : {testDetails.score} </span>
                        </div>
                        <div className="w-full text-center">
                            <button onClick={hanldeTestStart} className="w-[178px] h-[48px] px-3 py-2 bg-customPrimaryPurple text-white">Try again</button>
                        </div>
                        <div className="w-full">
                            <h1 className="font-bold">Instructions:</h1>
                            <ul class="list-disc list-inside text-gray-800">
                                <li>The test will automatically submit when the timer runs out, so manage your time wisely.</li>
                                <li>Please attempt all the questions to maximize your score.</li>
                                <li>The test has a strict time limit, so stay focused throughout.</li>
                                <li>Maintain honesty and integrity—avoid any unfair practices.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            )

        }
    } else {
        //if its false means not attempted 

        return (
            <div className="grow w-full p-20 overflow-y-scroll">
                <div className="flex flex-col gap-8 p-8 w-full bg-[#F1F3F6] justify-center">
                    <div className="font-semibold text-2xl text-center w-full">
                        Test
                    </div>
                    <div className="flex gap-6 justify-center">
                        <div className="flex p-4 gap-4 border bg-white items-center border-borderColor shadow-md w-[273px] h-[88px]">
                            <div className="p-4 rounded-full bg-[#EA852A19]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M19 19H8C4.70017 19 3.05025 19 2.02513 17.9749C1 16.9497 1 15.2998 1 12V1" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                    <path d="M4 10H4.00898M6.9982 10H7.00718M9.99641 10H10.0054M12.9946 10H13.0036M15.9928 10H16.0018M18.991 10H19" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4 5C4.67348 3.87847 5.58712 3 6.99282 3C12.9359 3 9.59545 15 15.9819 15C17.3976 15 18.3057 14.1157 19 13" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                </svg>
                            </div>
                            <div>
                                <div className="text-[#4F4F4F] font-normal text-sm">Time Allowed</div>
                                <div>{testDetails.timeLimit} minutes</div>
                            </div>
                        </div>
                        <div className="flex p-4 gap-4 border bg-white items-center border-borderColor shadow-md w-[273px] h-[88px]">
                            <div className="p-4 rounded-full bg-[#EA852A19]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                                    <path d="M21.6667 10.5667C21.6667 15.8499 17.1889 20.1334 11.6667 20.1334C11.0173 20.1343 10.3699 20.0742 9.73207 19.9545C9.27298 19.8682 9.04344 19.8251 8.88318 19.8496C8.72293 19.8741 8.49583 19.9948 8.04164 20.2364C6.75679 20.9197 5.25861 21.161 3.81777 20.893C4.3654 20.2194 4.7394 19.4112 4.90443 18.5448C5.00443 18.0148 4.75666 17.5 4.38555 17.1231C2.69999 15.4115 1.66666 13.1051 1.66666 10.5667C1.66666 5.28357 6.14443 1 11.6667 1C17.1889 1 21.6667 5.28357 21.6667 10.5667Z" stroke="#F2994A" stroke-width="1.5" stroke-linejoin="round" />
                                    <path d="M9.66666 8.84615C9.66666 7.82655 10.5621 7 11.6667 7C12.7712 7 13.6667 7.82655 13.6667 8.84615C13.6667 9.21368 13.5503 9.55612 13.3498 9.84381C12.7521 10.7012 11.6667 11.5189 11.6667 12.5385V13" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                    <path d="M11.6667 15.5H11.6756" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div>
                                <div className="text-[#4F4F4F] font-normal text-sm">No. of questions</div>
                                <div>{testDetails.numberOfQuestions}</div>
                            </div>
                        </div>
                        <div className="flex p-4 gap-4 border bg-white items-center border-borderColor shadow-md w-[273px] h-[88px]">
                            <div className="p-4 rounded-full bg-[#EA852A19]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
                                    <path d="M19.781 7.2C19.8334 8.25014 19.8334 9.49936 19.8334 11C19.8334 15.4783 19.8334 17.7175 18.4421 19.1088C17.0509 20.5 14.8117 20.5 10.3334 20.5C5.85503 20.5 3.61586 20.5 2.22462 19.1088C0.833374 17.7175 0.833374 15.4783 0.833374 11C0.833374 6.52166 0.833374 4.28249 2.22462 2.89124C3.61586 1.5 5.85503 1.5 10.3334 1.5C11.4053 1.5 12.3489 1.5 13.1834 1.51908" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" />
                                    <path d="M6.33337 10.5C6.33337 10.5 7.83337 10.5 9.83337 14C9.83337 14 14.8922 4.83333 19.8334 3" stroke="#F2994A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div>
                                <div className="text-[#4F4F4F] font-normal text-sm">Attempts</div>
                                <div>{attemptNumber}</div>
                            </div>
                        </div>
                    </div>
                    <div className="w-full text-center">
                        <button onClick={hanldeTestStart} className="w-[178px] h-[48px] px-3 py-2 bg-customPrimaryPurple text-white">Start</button>
                    </div>
                    <div className="w-full">
                        <h1 className="font-bold">Instructions:</h1>
                        <ul class="list-disc list-inside text-gray-800">
                            <li>The test will automatically submit when the timer runs out, so manage your time wisely.</li>
                            <li>Please attempt all the questions to maximize your score.</li>
                            <li>The test has a strict time limit, so stay focused throughout.</li>
                            <li>Maintain honesty and integrity—avoid any unfair practices.</li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    // if ( showFailModal ) {
    //     return (
    //         <div className="h-full flex justify-center items-center">
    //             <div style={{ minWidth: '20%' }} className="relative p-3 h-auto transform flex-col justify-evenly rounded-lg bg-white text-left shadow-xl transition-all my-8">
    //                 <div className='flex w-full justify-center'>
    //                     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-10">
    //                         <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
    //                     </svg>
    //                 </div>
    //                 <div className='font-bold text-center'>
    //                     Test Failed!
    //                 </div>
    //                 <div className="text-center">
    //                     <button onClick={() => {
    //                         setSidebarToggle(true);
    //                         setIsTestStarted(false);
    //                     }} className='p-3 rounded-xl text-white' style={{ backgroundColor: '#fa9248' }}>Go to course and try again</button>
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }

    // if (showPassModal) {
    //     return (
    //         <div className="h-full flex justify-center items-center">
    //             <div style={{ minWidth: '20%' }} className="relative p-3 h-auto transform flex-col justify-evenly rounded-lg bg-white text-left shadow-xl transition-all my-8">
    //                 <div className="flex justify-center">
    //                     <CompletedSVG />
    //                 </div>
    //                 <div className='font-bold text-center'>
    //                     Test Passed!
    //                 </div>
    //                 <div className="flex justify-center">
    //                     <button onClick={() => {
    //                         setSidebarToggle(true);
    //                         setIsTestStarted(false);
    //                         setShowFailModal(false);
    //                     }} className='p-3 rounded-xl text-white' style={{ backgroundColor: '#fa9248' }}>Go to course</button>
    //                 </div>
    //             </div>
    //         </div>
    //     )
    // }

    // return (
    //     <div className="h-full flex flex-col w-4/6 grow">
    //         <TopicSubTopicView nameOne={topicName} nameTwo={testName} />
    //         <TestInfoView questionsArray={questionsArray} currentQuestionId={currentQuestionId} />
    //         <CountdownTimer time={testTimeMinutes} onFinish={handleTestSubmit} isTestSubmitted={isTestSubmitted} />
    //         <Question question={question} setQuestion={setQuestion} setQuestionsArray={setQuestionsArray} />
    //         <TestFooter
    //             currentQuestionId={currentQuestionId}
    //             disablePrevious={disablePrevious}
    //             disableNext={disableNext}
    //             nextQuestion={nextQuestion}
    //             isSpeaking={isSpeaking}
    //             previousQuestion={previousQuestion}
    //             handleTextToSpeech={handleTextToSpeech}
    //             handleTestSubmit={handleTestSubmit}
    //             questionsArray={questionsArray}
    //         />
    //     </div>
    // );
}

export default TestConsumption;